handleGetCheckoutOrderData